<!-- 1-1-2 页面 -->
<template>
  <div>
    <PanelV2
      type="w1"
      title="aaa"
      showGoBack
      mode="simple"
    >
      <template v-slot:title-solt>
        <span class="btn-action">EDIT</span>
      </template>

      <template v-slot:content-solt>
        type: w1
      </template>
    </PanelV2>

    <PanelV2
      type="w2"
      title="aaa"
    >
      <template v-slot:title-solt>
        <BdoProgress />
      </template>
      <template v-slot:content-solt>
        type: w2
      </template>
    </PanelV2>

    <PanelV2
      type="w3"
      title="aaa"
    >
      <template v-slot:content-solt>
        type: w3
      </template>
    </PanelV2>

    <PanelV2
      type="w4"
      title="aaa"
    >
      <template v-slot:content-solt>
        type: w4
      </template>
    </PanelV2>

    <PanelV2
      type="w5"
      title="aaa"
    >
      <template v-slot:content-solt>
        type: w5
      </template>
    </PanelV2>

    <PageContent>
      <StepsV2 />
      <PanelV2
        type="w6"
        title="Enter your business address"
      >
        <template v-slot:title-solt>
          <BdoProgress />
        </template>
        <template v-slot:content-solt>
          <AppForm1
            ref="appForm1"
            v-model="formData"
           />
        </template>
      </PanelV2>
    </PageContent>

    <PageContent>
      <StepsV2 :step="2" />
      <PanelV2
        type="w6"
        title="Enter your business address"
      >
        <template v-slot:title-solt>
          <BdoProgress />
        </template>
        <template v-slot:content-solt>
          <AppForm2
            ref="appForm2"
            v-model="formData"
           />
        </template>
      </PanelV2>
    </PageContent>

    <PageContent>
      <StepsV2 type="s3" :step="2" />
      <PanelV2
        type="w6"
        title="Enter your business address"
      >
        <template v-slot:title-solt>
          <BdoProgress />
        </template>
        <template v-slot:content-solt>
          <AppForm2
            ref="appForm2"
            v-model="formData"
            :toggleContact="toggleContact"
           />
        </template>
      </PanelV2>
    </PageContent>

    <PanelV2
      type="w7"
      title="aaa"
    >
      <template v-slot:content-solt>
        type: w7
      </template>
    </PanelV2>

    <PanelV2
      type="w8"
      title="aaa"
    >
      <template v-slot:content-solt>
        type: w8
      </template>
    </PanelV2>

    <PanelV2
      type="w7"
      title="Get to know the digital products that can help you grow your business"
    >
      <template v-slot:content-solt>
        <Digital />
      </template>
    </PanelV2>

    <PanelV2
      type="w6"
      :title="$t('APP-FIELD-0265')"
    >
      <template v-slot:title-solt>
        <BdoProgress total="2" />
      </template>
      <template v-slot:content-solt>
        <IdCardUpload photoType="idCard" />
      </template>
    </PanelV2>
    <!-- requirements页面 -->
    <Requirements :process="2"> </Requirements>
    
    <!-- 打开弹框按钮 -->
    <el-button type="text" @click="openDialog">打开内容框</el-button>
    <el-button type="text" @click="openModal">打开确认框</el-button>

    <!-- 模态框组件 -->
    <DialogV1 v-if="showDialog" @closeDialog="closeDialog" :needDisagree="true" :btn_name="'按钮内容'" >
      <template v-slot:dia-content-title>标题</template>
      <template v-slot:dia-content-solt> 内容</template>
      <template v-slot:dia-content-cbc> 已阅读</template>    
    </DialogV1>

    <!-- 确认弹窗组件 -->
    <ModalDisagree
      v-if="showModal"
      @closeModal="closeModal"
      :lbtnName="'Back'"
      :rbtnName="'Confirm'"
    >
      <template v-slot:modal_title>By disagreeing to the Merchant Agreement, you are<br />
        discontinuing your <strong>BDO Merchant</strong> application</template>
    </ModalDisagree>

  <InfoBox></InfoBox>
  
  <PanelV2
      type="w6"
      title="What's your BDO Settlement Account?"
    >
      <template v-slot:title-solt>
      </template>
      <template v-slot:content-solt>
        <SettlementAccount/>
      </template>
    </PanelV2>
  </div>
</template>

<script>

  // import Panel from "../components/Panel";
  import PanelV2 from "../components/PanelV2";
  import IdCardUpload from "../pages/common/IdCardUpload.vue";
  import AppForm1 from "../forms/ExistingBDOMerchant.val";
  import AppForm2 from "../forms/ExistingBDOPartner.val";
  import Requirements from "../components/Requirements";
  import DialogV1 from "../components/DialogV1";
  import ModalDisagree from "../components/ModalDisagree";

  export default {
    name: 'Demo2',
    pRouter:'App',
    components: {
      // Panel,
      PanelV2,
      IdCardUpload,
      AppForm1,
      AppForm2,
      Requirements,
      DialogV1,
      ModalDisagree,
    },
    created() {
      window.loadI18NData('en', () => {});
    },
    data(){
      return{
        showDialog:false,
        showModal:false,
      }
    },
    methods: {
      onPanelClick(type) {
        if(type === 1) {
          this.$router.push({name: 'AgencyBanking'})
        }else if(type === 2) {
          this.$router.push({name: 'AgencyBanking'})
        }
        console.log(type)
      },
      openDialog() {
        this.showDialog = true;
      },
      closeDialog() {
        this.showDialog = false;
      },
      openModal() {
        this.showModal = true;
      },
      closeModal() {
        this.showModal = false;
      },
    }
  }
</script>

<style lang="scss" scoped>
  // .content-area {
  //   padding-bottom: 164px;
  //   .panel-one {
  //     margin: 31px 0 26px;
  //   }
  // }
</style>
